<template>
	<card class="ReCardClientEdit">
		<div class="d-flex align-items-center">
			<h3 class="mb-1 mr-2">{{strFIO}}</h3> 
			<span class="badge badge-pill badge-success" v-if="(objClient.client_type == 1) && bIsNew">ФИЗ ЛИЦО</span>
			<span class="badge badge-pill badge-primary" v-if="(objClient.client_type == 2) && bIsNew">ЮР ЛИЦО</span>	
			<base-button v-if="parseInt($GVO.my_profile.adm) == 1" class="ml-2" @click="REM_PD_ACC_query()" type="danger" simple>Отозвать ПД</base-button>
		</div>
		<h4 v-if="bIsNew">Редактирование данных клиента</h4>
		<div v-if="!bIsNew" class="col-md-12 checkbox-radios mb-3">
			<base-radio v-for="(el_opt, el_index) in rbClientType" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="rbClientType_model" inline>{{el_opt.label}}</base-radio>
		</div>
		
		<hr>

		<div class="form-group col-md-12">
			<!-- <div class="row" v-if="element.elementType == 'fio-padej' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" :class="[{'formRequired':element.required===true}]"><span>{{ element.label }} </span></label>
				<div class="form-group col-md-12">
					<ReFioPadej
						:findId="element.elementGetParamMap"
						:required="element.required"
						v-model="element.element_model" />
				</div>
			</div> -->
		</div>
		
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"/>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	import { BaseRadio } from 'src/components/index';
	// import ReFioPadej from 'src/our_components/ReFioPadej.vue';

	export default {
		name: 'ReCardClientEdit',
		components: {
			ReFormPrinter,
			BaseRadio,
			// ReFioPadej,
		},
		props: {
			objClient: Object,
		},
		data () {
			return {
				ver: 1,
				currentApiFormMethod: this.currentApiFormMethodComp(),
				masAllFormParams: this.currentFormConfig(),//(typeof this.$route.query.client_type === 'undefined' || this.$route.query.client_type === '1')?this.currentFormConfig():this.currentFormConfigUr(),//this.currentFormConfig()
				rbClientType: [{name: '1', label: 'ФИЗ ЛИЦО',},{name: '2', label: 'ЮР ЛИЦО',}],
				rbClientType_model: typeof this.$route.query.client_type !== 'undefined'?this.$route.query.client_type:'1',	
				strMethod: '',					
			}
		},
		watch:{
			rbClientType_model(val){
				if(!this.bIsNew) this.currentFormConfig();
				/*
				if(!this.bIsNew){
					if(val == '1'){
						this.masAllFormParams = this.currentFormConfig();
					}
					if(val == '2'){
						this.masAllFormParams = this.currentFormConfigUr();
					}
				}
				*/
			},
		},
		computed: {
			bIsNew: function(){
				if(location.pathname.indexOf('/data/clients/add') === -1){
					return true;
				}
				return false;
			},
			strFIO: function(){
				if(typeof this.objClient.id!='undefined'){
					//return [this.objClient.surname,this.objClient.name,this.objClient.patronymic].join(' ');
					return this.objClient.fio;
				}
				return 'Новый клиент';
			},
		},
		methods: {
			formMethod(){
				return (this.rbClientType_model||this.$route.query.client_type||1)==1?'GET_FORM':'GET_FORM_UR';
			},

			REM_PD_ACC_query(){
				this.$GVO.showYesNo(this.REM_PD_ACC,'Удаление ПД','Вы действительно хотите удалить все ПД клиента?');
			},
			REM_PD_ACC(){
				
				let client_id = typeof this.$route.params.client_id == 'undefined'?'-1':this.$route.params.client_id;
				this.$GVO.ApiCall('REM_PD_ACC' ,{obj:'client',flt:{'client_id':client_id}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						//this.masAllFormParams = objApi.config;
						//location.href = '/data/clients/id/'+client_id;
						this.currentFormConfig();
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			},
			currentApiFormMethodComp(){
				let client_id = typeof this.$route.params.client_id == 'undefined'?'-1':this.$route.params.client_id;
				/*if(location.pathname.indexOf('/data/clients/add') != -1){
					return {apiMethod:'INS',apiParam:{obj:'client' ,flt:{id:'-1'},iData:[]}};
				} else {
					let client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
					//this.objClient.id
					return {apiMethod:'UPD',apiParam:{obj:'client' ,flt:{id:client_id},uData:[]}};
				}*/
				
				
				return {apiMethod:'INSUPD',apiParam:{obj:'client' ,flt:{id:client_id},iData:[]}};
			},
			currentFormConfig(){
				this.masAllFormParams=[];
				let client_id = typeof this.$route.params.client_id == 'undefined'?'-1':this.$route.params.client_id;
				let prePhoneValue;
				if(location.pathname.indexOf('/data/clients/add') != -1){
					this.strMethod = this.formMethod()+'_START';
					if(typeof this.$route.query.contact_value != 'undefined'){
						prePhoneValue = this.$route.query.contact_value;
					}
				} else {
					this.strMethod = this.formMethod();//'GET_FORM';
				}
				
				this.$GVO.ApiCall(this.strMethod ,{obj:'client',flt:{'id':client_id,'prePhoneValue':prePhoneValue}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
				
				
				return [];
			},
			currentFormConfigUr(){
				return false;
				let client_id = typeof this.$route.params.client_id == 'undefined'?'-1':this.$route.params.client_id;
				if(location.pathname.indexOf('/data/clients/add') != -1){this.strMethod = 'GET_FORM_UR_START';} else {this.strMethod = 'GET_FORM_UR';}

				this.$GVO.ApiCall(this.strMethod,{obj:'client',flt:{id:client_id}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
				return [];
			},
			SuccessGo(evt,dopParam){
				if(location.pathname.indexOf('/data/clients/add') != -1){
					// console.log('SuccessGo',evt,dopParam,typeof dopParam.data.new_id);
					if(typeof dopParam.data.new_id != 'undefined'){
						// console.log(dopParam.data.new_id);
						this.$router.push({path: '/data/clients/id/'+dopParam.data.new_id});
					}else{
						this.$router.push({path: '/data/clients'});
					}
				}else{
					this.$router.push({path: this.$GVO.str_replace('/edit','',evt)});
					// console.error('SuccessGo',evt);
				}
			},
		},
		mounted() {
			
		},
	}
</script>
<style scoped>
	.ReCardClientEdit hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
	}
	.ReCardClientEdit >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
	.ReCardClientEdit .badge {font-size: 0.7rem; height: fit-content;}
</style>
